import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../../components/useListadoRecordado';
import axios from '../../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import './ShowPagos.css';
import { useLoading } from '../../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../../components/PaginationTable';
import GraficaBarras from '../../../components/GraficaBarras';
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaUserFriends, FaClock, FaBook,FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import { RiCoinsFill} from "react-icons/ri";
import { TbCoins } from "react-icons/tb";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { FaExpand, FaCompress } from 'react-icons/fa'; // Íconos para expandir/contraer
import { motion } from 'framer-motion';
import { FaCoins } from 'react-icons/fa';



const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];



// Montos del reporte en dólares, con separador de miles.
// Espacio no separable (\u00a0) para que el "$" no se parta en otra línea de la etiqueta.
const formatoMonto = (v) => `${Number(v || 0).toLocaleString('es-VE', { maximumFractionDigits: 2 })}\u00a0$`;

const ShowPagos = () => {
    const [reportes, setReportes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filteredReportes, setFilteredReportes] = useState([]);
    const [searchCedula, setSearchCedula] = useState('');
    const [error, setError] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const userRole = localStorage.getItem('role'); // Obtener el rol del usuario desde el localStorage
    const itemsPerPage = 4; // Número de elementos por página
    const [totalPagos, setTotalPagos] = useState(0);
    const [totalMontoCancelado, setTotalMontoCancelado] = useState(0);
    const [montoPorCentro, setMontoPorCentro] = useState([]);
    const [latestTasa, setLatestTasa] = useState({ tasa: 0, created_at: '' });
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [range, setRange] = useState(30); // Estado para seleccionar el rango de días
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [centroOptions, setCentroOptions] = useState([]);
    const [cohorteOptions, setCohorteOptions] = useState([]);
    const [periodoOptions, setPeriodoOptions] = useState([]);
    const [tipoPagoOptions, setTipoPagoOptions] = useState([]);
    const [formaPagoOptions, setFormaPagoOptions] = useState([]);
    const [cursoOptions, setCursoOptions] = useState([]);

    const [showModalInfo, setShowModalInfo] = useState(false);
    const [mostrarSoloTabla, setMostrarSoloTabla] = useState(false);
              
    const toggleTablaExpandida = () => {
        setMostrarSoloTabla(prevState => !prevState);
    };  

     // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
     const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('pagos', {
                cedula_identidad: '',
                cohorte: '',
                centro_id: '',
                periodo_id: '',
                curso_id: '',
                tipo_pago_id:'',
                forma_pago_id:'',
                fecha_pago:'',
                fecha_pago2:'',
                nombres:'',
                apellidos:'',
            });
            const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");
    
    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };   
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        setLoading(true);
        Promise.all([getAllReportes(currentPage),getLatestTasaBCV(),fetchFilterOptions()]).finally(() => {
            setLoading(false);
        });
    }, []);

   // Nueva función para obtener los reportes y estadísticas en una sola solicitud
const getAllReportes = async (page = 1) => {
    // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
    // un número es la página 1. Y la página mostrada se fija aquí, así
    // coincide siempre con los datos (buscar, recargar, borrar, paginar).
    const pagina = Number.isInteger(page) && page > 0 ? page : 1;
    setCurrentPage(pagina);
    setLoading(true);
    try {
        const token = localStorage.getItem('token');

        // Realiza la solicitud a la nueva ruta con estadísticas
        const response = await axios.get(`/pagos-estadisticas`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page: pagina },
        });

        // Actualiza los datos de la tabla paginada
        const reportes = response.data.datos.data || []; // Asegura que no haya errores si `data` está vacío
        setReportes(reportes);
        setFilteredReportes(reportes);
        setTotalPagos(response.data.estadisticas.totalPagos); // Total de pagos de las estadísticas
        setTotalMontoCancelado(response.data.estadisticas.totalMontoCancelado); // Promedio del monto cancelado
        setMontoPorCentro(response.data.estadisticas.montoPorCentro || []);
        setTotalPages(response.data.datos.last_page || 1); // Total de páginas para la paginación
         setLoading(false);

    } catch (error) {
        setError('Error fetching data');
        console.error('Error fetching data:', error);
    }
};

const fetchFilterOptions = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/filter-inscripciones`, { headers: { Authorization: `Bearer ${token}` } });

        setCentroOptions(response.data.centro);
        setCohorteOptions(response.data.cohorte);
        setPeriodoOptions(response.data.periodo);
        setTipoPagoOptions(response.data.tipo_pago);
        setFormaPagoOptions(response.data.forma_pago);
        setCursoOptions(response.data.cursos || []);

    } catch (error) {
        setError('Error fetching filter options');
        console.error('Error fetching filter options:', error);
    }
};

// Función para manejar el cambio de página
const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Actualiza la página actual
    getAllReportes(newPage); // Obtiene los datos para la nueva página
};


const getBCV = async () => {
    try {
        console.log("Llamando a /get");

        const token = localStorage.getItem('token');
        const response = await axios.get(`/tasa-bcv/get`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          

        });

        loadData();
    } catch (error) {
        console.error('Error al obtener la última tasa BCV:', error);
    }
};

    const getLatestTasaBCV = async () => {
        try {
            const response = await axios.get(`/tasa_bcv`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            setLatestTasa({ tasa: response.data.tasa, created_at: response.data.created_at });
        } catch (error) {
            console.error('Error al obtener la última tasa BCV:', error);
        }
    };
    
    
    const deleteReporte = async () => {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/pagos/${selectedId}`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                getAllReportes();
                setShowModal(false); // Cierra el modal tras la eliminación exitosa
                toast.success('Reporte eliminado con éxito');
            } catch (error) {
                setError('Error deleting data');
                console.error('Error deleting data:', error);
                toast.error('Error al eliminar el reporte');
            }
        
    };

    if (error) {
        return <div>{error}</div>;
    }

    const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {
            await (getAllReportes(),getLatestTasaBCV()); // Espera a que getAllDatos haga la solicitud y actualice los datos
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };


    const printInfo = async (filters) => {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            alert("Token no encontrado.");
            return;
          }
      
          // Realizar la solicitud GET a la ruta que genera los datos en JSON
          const response = await axios.get(`/pagos-estadisticas-print`, {
            headers: { Authorization: `Bearer ${token}` },
            params: filters, // Pasamos los filtros a la ruta
          });
      
          // Extraer los datos principales y las estadísticas
          const jsonData = response.data.datos; // Clave 'datos'
          const estadisticasData = response.data.estadisticas; // Clave 'estadisticas'
      
          if (!jsonData || jsonData.length === 0) {
            alert("No hay datos para exportar.");
            return;
          }
      
          // Convertir los datos principales a una hoja
          const worksheet1 = XLSX.utils.json_to_sheet(jsonData); // Hoja de datos
          const workbook = XLSX.utils.book_new(); // Crea un libro nuevo
          XLSX.utils.book_append_sheet(workbook, worksheet1, "Datos"); // Añade la hoja al libro
      
          // Preparar las estadísticas para convertirlas
          const estadisticasArray = Object.entries(estadisticasData).map(([key, value]) => ({
            Estadística: key,
            Valor: value,
          }));
      
          // Convertir las estadísticas a una hoja
          const worksheet2 = XLSX.utils.json_to_sheet(estadisticasArray);
          XLSX.utils.book_append_sheet(workbook, worksheet2, "Estadísticas"); // Añade la segunda hoja
      
          // Generar el archivo Excel
          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      
          // Crear un Blob y guardarlo como archivo
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "pagos_estadisticas.xlsx");
        } catch (error) {
          console.error("Error al generar el archivo Excel", error);
          alert("Hubo un error al generar el archivo Excel");
        }
      };

      const handlePrint = async () => {
        setShowModalInfo(false); // Cerrar el modal
        await printInfo(filters); // Llamar a la función de impresión con los filtros
      };

    const columns = ["id", "Cédula","Nombres","Apellidos", "Fecha de Pago", "Fecha de Reporte","Tipo de Pago", "Monto Cancelado", "Curso", "Comentario","Acciones"];

    const renderItem = (reporte) => (
        <tr key={reporte.id}>
        <td className="col-idq">{reporte.id}</td>
        <td className="col-cedulaq">{reporte.cedula_identidad}</td>
        <td className="col-cedulaq">{reporte.nombres}</td>
        <td className="col-cedulaq">{reporte.apellidos}</td>
        <td className="col-fechaq">{moment(reporte.fecha_pago).format('YYYY-MM-DD')}</td>
        <td className="col-fechaq">{moment(reporte.fecha).format('YYYY-MM-DD')}</td>
         <td className="col-montoq">{reporte?.tipo_pago?.descripcion} </td>
        <td className="col-montoq">{reporte.monto_cancelado} $</td>
        <td className="col-montoq">{reporte.curso_descripcion} </td>
       
        <td className="col-comentarioq">{reporte.comentario_cuota}</td>
        <td className="col-accionesq">
            <div className="d-flex justify-content-around">

                <Button
                    variant="btn btn-info" 
                    onClick={() => navigate(`/pagos/${reporte.id}`)}
                    className="me-2"
                    title= "Ver más"
                >
                    <i className="bi bi-eye"></i>
                </Button>

               
                {userRole === 'admin' && (
                

                <Button
                variant="btn btn-danger"
                onClick={() => handleShowModal(reporte.id)}
                className="me-2"
                title= "Eliminar"
                >
                <i className="bi bi-trash3-fill"></i>
                </Button>
                )}
            </div>
        </td>
        </tr>
    );

    return (
        <div className="container-fluid mt-2" style={{ fontSize: '0.85rem' }}>
             <motion.div 
                initial={{ opacity: 1, maxHeight: "500px" }} // Establece una altura máxima inicial
                animate={{
                    opacity: mostrarSoloTabla ? 0 : 1,
                    maxHeight: mostrarSoloTabla ? 0 : "500px", // Reduce la altura en transición
                }}
                transition={{ duration: 0.5, ease: "easeInOut" }} // Animación más fluida
                style={{ overflow: "hidden" }} // Evita que los elementos internos se muestren fuera de la caja
            >
            <div className="col-lg-11 mx-auto"> 
            <div className="stat-box d-flex justify-content-between" style={{ maxWidth: '100%' }}>
                {/* Total de Pagos */}
                <div className="stat-card" style={{ padding: '5px', margin: '0 10px', width: '22%' }}>
                    <div className="stat-icon"><RiCoinsFill /></div>
                    <div className="stat-number" style={{ color: '#58c765', fontSize: '1.2rem' }}>{totalPagos}</div>
                    <div className="stat-label">Total de Pagos</div>
                </div>

                {/* Promedio de Monto Cancelado */}
                <div className="stat-card" style={{ padding: '5px', margin: '0 10px', width: '22%' }}>
                    <div className="stat-icon"><TbCoins /></div>
                    <div className="stat-number" style={{ color: '#ffda1f', fontSize: '1.2rem' }}>{totalMontoCancelado} $</div>
                    <div className="stat-label">Total de Monto Cancelado</div>
                </div>

                {/* Última Tasa BCV */}
                <div className="stat-card" style={{ padding: '5px', margin: '0 10px', width: '22%' }}>
                    <div className="stat-icon"><FaClock /></div>
                    <div className="stat-number" style={{ color: '#ffda1f', fontSize: '1.6rem' }}>{latestTasa.tasa}</div>
                    <div className="stat-label" style={{ fontSize: '0.8rem', color: 'gray' }}>Última tasa BCV registrada</div>
                    <div className="stat-date" style={{ fontSize: '0.8rem', color: '#888' }}>{moment(latestTasa.created_at).format('YYYY-MM-DD')}</div>
                </div>
            </div>
            </div>

            </motion.div>

            <div className="row" style={{ marginTop: '10px' }}>
           



                {/* Columna para la tabla */}
                <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}

                    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}> 
                        
                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
                        <h2>Lista de Reportes de Pagos</h2>
                        <div className="d-flex align-items-center">
                        <Button
                            variant="info me-2"
                            onClick={getBCV}
                            style={{ padding: '5px 10px', width: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                            title="Recargar Tasa Bcv"
                            >
                            <FaCoins /> BCV
                            </Button>
                             <Button 
                                variant="info me-2" 
                                onClick={toggleTablaExpandida} 
                                style={{ padding: '5px 15px' }}
                                title={mostrarSoloTabla ? "Mostrar Todo" : "Modo Tabla Expandida"}
                            >
                                {mostrarSoloTabla ? <FaCompress /> : <FaExpand />}
                            </Button>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Cédula"
                                value={filters.cedula_identidad} // Conecta el campo de cédula al estado de filtros
                                name="cedula_identidad"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.cedula_identidad)}
                            />
                            <Button
                                variant="info me-2"
                                onClick={loadData}
                                disabled={loadingData} // Deshabilita el botón si está cargando
                                style={{ padding: '5px 10px', width: '90px' }} // Ajusta padding y ancho
                                title= "Recargar datos"

                                >
                                {/* Icono de recarga */}
                                {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                ) : (
                                    <FaSync />
                                )}
                            </Button>

                            <Button 
                                    variant="info me-2" 
                                    onClick={getAllReportes}
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title="Buscar"
                                >
                                    <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                </Button>

                                  {/* Botón con el icono de impresora */}
                            <Button
                                variant="btn btn-info"
                                onClick={() => setShowModalInfo(true)} // Abrir el modal
                                className="me-2"
                                title="Exportar en Excel"
                            >
                                <i className="bi bi-printer-fill"></i> {/* Icono de impresora */}
                            </Button>

                            {userRole === 'admin' || userRole === 'asist-centro' ? (

                            <Button variant="btn custom" onClick={() => navigate('/pagos/create')} className="btn-custom" title="Crear Nuevo Reporte de Pago">
                            <i className="bi bi-cash-coin me-2  "></i> Nuevo
                            </Button>
                            ):null}
                        </div>
                    </div>
                    
                    <div className="d-flex align-items-center" style={{ gap: '10px' }}> {/* Ajusta el espacio entre el buscador y el filtro */}
                    <Form.Select
                            name="tipo_pago_id"
                            value={filters.tipo_pago_id}
                            onChange={handleFilterChange}
                            className={activeFilterClass(filters.tipo_pago_id)}
                        >
                            <option value="">Tipo de Pago</option>
                            {tipoPagoOptions?.map(option => (
                                <option key={option.id} value={option.id}>{option.descripcion}</option>
                            ))}

                        </Form.Select>

                        <Form.Select
                            name="forma_pago_id"
                            value={filters.forma_pago_id}
                            onChange={handleFilterChange}
                            className={activeFilterClass(filters.forma_pago_id)}
                        >
                            <option value="">Forma de Pago</option>
                            {formaPagoOptions?.map(option => (
                                <option key={option.id} value={option.id}>{option.descripcion}</option>
                            ))}

                        </Form.Select>
                        <Form.Select
                            name="centro_id"
                            value={filters.centro_id}
                            onChange={handleFilterChange}
                            className={activeFilterClass(filters.centro_id)}
                        >
                            <option value="">Centro</option>
                            {centroOptions?.map(option => (
                                <option key={option.id} value={option.id}>{option.descripcion}</option>
                            ))}

                        </Form.Select>
                        <Form.Select
                            name="cohorte"
                            value={filters.cohorte}
                            onChange={handleFilterChange}
                            className={activeFilterClass(filters.cohorte)}
                        >
                            <option value="">Cohorte</option>
                            {cohorteOptions?.map(option => (
                                <option key={option.id} value={option.descripcion}>{option.descripcion}</option>
                            ))}

                        </Form.Select>
                        <Form.Select
                            name="periodo_id"
                            value={filters.periodo_id}
                            onChange={handleFilterChange}
                            className={activeFilterClass(filters.periodo_id)}
                        >
                            <option value="">Periodo</option>
                            {periodoOptions?.map(option => (
                                <option key={option.id} value={option.id}>{option.descripcion}</option>
                            ))}

                        </Form.Select>
                        <Form.Select
                            name="curso_id"
                            value={filters.curso_id}
                            onChange={handleFilterChange}
                            className={activeFilterClass(filters.curso_id)}
                        >
                            <option value="">Unidad Curricular</option>
                            {cursoOptions?.map(option => (
                                <option key={option.id} value={option.id}>
                                    {option.cod ? `${option.cod} - ${option.descripcion}` : option.descripcion}
                                </option>
                            ))}
                        </Form.Select>
                             



                        </div >
                          {/* Fecha con label en la misma línea */}
                          
                          <div className="d-flex align-items-center mb-3">
                            <Form.Label className="me-2 mb-0">Fecha Pago mayor que: </Form.Label>
                            <Form.Control
                            type="date"
                            name="fecha_pago"
                            value={filters.fecha_pago}
                            onChange={handleFilterChange}
                            style={{ width: 'auto' }}
                            className={activeFilterClass(filters.fecha_pago)}
                            />

                             <Form.Label className="me-2 mb-0">Fecha Pago menor que: </Form.Label>
                            <Form.Control
                            type="date"
                            name="fecha_pago2"
                            value={filters.fecha_pago2}
                            onChange={handleFilterChange}
                            style={{ width: 'auto' }}
                            className={activeFilterClass(filters.fecha_pago2)}
                            />
                                </div>  
                                <div className="d-flex align-items-center mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Nombre"
                                value={filters.nombres} // Conecta el campo de cédula al estado de filtros
                                name="nombres"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.nombres)}
                            />
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Apellido"
                                value={filters.apellidos} // Conecta el campo de cédula al estado de filtros
                                name="apellidos"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.apellidos)}
                            />
                                </div>  

                    {/* Tabla paginada */}
                    <PaginationTable
                        data={filteredReportes}
                        itemsPerPage={itemsPerPage}
                        columns={columns}
                        renderItem={renderItem}
                        currentPage={currentPage}
                        onPageChange={handlePageChange} // Llama a `handlePageChange` para cambiar la página
                        totalPages={totalPages}
                    />

                    {/* Monto recaudado por centro (punto 8 de José, 25/09/2026). Usa los
                        mismos filtros que la tabla: la suma de las barras es el total. */}
                    {!mostrarSoloTabla && (
                        <div className="mt-4">
                            <GraficaBarras
                                titulo="Monto recaudado por centro"
                                nota="Suma del monto cancelado de los pagos filtrados, según el centro de la inscripción. Solo centros con monto mayor a 0."
                                datos={montoPorCentro.filter((c) => Number(c.monto) > 0)}
                                campo="monto"
                                formato={formatoMonto}
                                tooltip={(valor, item) => [`${formatoMonto(valor)} (${item?.payload?.pagos ?? 0} pagos)`, 'Recaudado']}
                                queSeCuenta="monto recaudado"
                                nombreSerie="Recaudado"
                                color="#58c765"
                            />
                        </div>
                    )}


                    {/* Modal  de eliminación */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar eliminación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>¿Estás seguro de que deseas eliminar este Reporte de Pago?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancelar
                    </Button>
                    <Button variant="danger" onClick={deleteReporte}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
             {/* Modal de confirmación */}
                <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} centered>
                    <Modal.Header closeButton>
                    <Modal.Title>Confirmar impresión</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    ¿Está seguro que desea imprimir la información? Esto generará un archivo descargable en formato Excel.
                    </Modal.Body>
                    <Modal.Footer>
                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={() => setShowModalInfo(false)}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handlePrint}>
                            Imprimir
                        </Button>
                        </div>

                    </Modal.Footer>
                </Modal>
            <ToastContainer />
        </div>
       
        </div>
        </div>
        </div>
    );
};

export default ShowPagos;
